module.exports = __webpack_public_path__ + "static/media/rekart_color.10b85e69.png";